import React from "react";
import classes from "./EventWrapper.module.scss";

const toPercent = (n) => {
  if (n === undefined || n === null || n === "") {
    return 0;
  }

  if (typeof n === "string") {
    return n;
  }

  return `${n}%`;
};

const getEventZIndex = (event) => {
  if (event?.availabilityGrid) {
    return 0;
  }

  if (event?.zIndex === undefined || event?.zIndex === null) {
    return event?.appointmentType === "break_time" ? 1 : 3;
  }

  return event.zIndex;
};

export function EventWrapper({ style, event, children }) {
  const availableTimeWidth = "100%";
  const gridLeft = 0;

  const isBreakTime = event.appointmentType === "break_time";
  const noInteraction = event.noClickEvents || isBreakTime;

  return (
    <div
      data-tip={noInteraction ? event.title : undefined}
      className={[
        classes.root,
        isBreakTime ? classes.pointerPassthrough : "",
      ].join(" ")}
      style={{
        ...style,
        height: toPercent(style?.height),
        width: event.availabilityGrid
          ? availableTimeWidth
          : toPercent(style?.width),
        top: toPercent(style?.top),
        left: event.availabilityGrid ? gridLeft : toPercent(style?.xOffset),
        zIndex: getEventZIndex(event),
      }}
    >
      {noInteraction ? (
        <div className={classes.noInteraction}>{children}</div>
      ) : (
        children
      )}
    </div>
  );
}
